import { ConfirmElectronicConsentArgs } from '@hb/shared'
import { httpsCallable } from 'firebase/functions'
import { functions } from '../../../../../backend/functions'

export const confirmElectronicConsent = httpsCallable<ConfirmElectronicConsentArgs>(
  functions,
  'confirmElectronicConsent',
)
